import React from 'react';
import { Button, Card, CardBody, Col } from 'reactstrap';
import { Field } from 'react-final-form';
import ReduxFormInputTranslation from '@Utils/ReduxFormInputTranslation';
import { defaultMessages } from '@I18n/default';
import ReduxFormInput from '@Utils/ReduxFormInput';
import ReduxFormCheck from '@Utils/ReduxFormCheck';

export interface MagicItemComponentProps {
  name: string;
  disabled: boolean;
  form: any;
  fields: any;
  index: number;
}

const MagicItemComponent: React.FC<MagicItemComponentProps> = ({
  name,
  disabled,
  form,
  fields,
  index,
}) => {
  return (<Col xs={12} md={6} lg={4} key={name}>
    <Card className={'mb-2'}>
      <CardBody>
        <Field
          name={`${name}.name`}
          type="text"
          disabled={disabled}
          loc={form.getFieldState('loc')}
          component={ReduxFormInputTranslation}
          label={
            defaultMessages.publicationArmyBookFormMagicItemNameLabel
          }
          placeHolder={
            defaultMessages.publicationArmyBookFormMagicItemNamePlaceholder
          }
        />
        <Field
          name={`${name}.type`}
          type="text"
          disabled={disabled}
          component={ReduxFormInput}
          label={
            defaultMessages.publicationArmyBookFormMagicItemTypeLabel
          }
          placeHolder={
            defaultMessages.publicationArmyBookFormMagicItemTypePlaceholder
          }
        />
        <Field
          name={`${name}.cost`}
          type="text"
          disabled={disabled}
          component={ReduxFormInput}
          label={
            defaultMessages.publicationArmyBookFormMagicItemCostLabel
          }
          placeHolder={
            defaultMessages.publicationArmyBookFormMagicItemCostPlaceholder
          }
        />
        <Field
          name={`${name}.support`}
          type="text"
          disabled={disabled}
          component={ReduxFormInput}
          label={
            defaultMessages.publicationArmyBookFormMagicItemSupportLabel
          }
          placeHolder={
            defaultMessages.publicationArmyBookFormMagicItemSupportPlaceholder
          }
        />
        <Field
          name={`${name}.rarity`}
          type="text"
          disabled={disabled}
          component={ReduxFormInput}
          label={
            defaultMessages.publicationArmyBookFormMagicItemRarityLabel
          }
          placeHolder={
            defaultMessages.publicationArmyBookFormMagicItemRarityPlaceholder
          }
        />
        <Field
          name={`${name}.dominant`}
          disabled={disabled}
          component={ReduxFormCheck}
          label={
            defaultMessages.publicationArmyBookFormMagicItemDominantLabel
          }
        />
        <Field
          name={`${name}.restriction`}
          type="text"
          disabled={disabled}
          component={ReduxFormInput}
          label={
            defaultMessages.publicationArmyBookFormMagicItemRestrictionLabel
          }
          placeHolder={
            defaultMessages.publicationArmyBookFormMagicItemRestrictionPlaceholder
          }
        />
        <Button
          type="button" className="btn btn-age"
          onClick={() => fields.remove(index)}
        >
          Remove
        </Button>
      </CardBody>
    </Card>
  </Col>);
};

export default MagicItemComponent;
